<template>
  <div class="form-group" :class="{ 'has-error': showError }">
    <div class="col-lg-4">
      <label class="control-label">Liability</label>
      <p class="help-block">Please select the liability type</p>
    </div>
    <div class="col-lg-8">
      <div class="input-group">
        <select class="form-control" name="liability" v-model="liability.type">
          <option value="">Please Select</option>
          <option
            :value="liabilityType.identifier"
            :key="liabilityType.id"
            v-for="liabilityType in liabilityTypes"
          >
            {{ liabilityType.label }}
          </option>
        </select>

        <span class="input-group-btn">
          <form-button
            :indicator="liability.processing()"
            v-on:clicked="setLiability"
          >
            UPDATE LIABILITY
          </form-button>
        </span>
      </div>

      <span class="text-danger" v-if="showError">
        The liability field is required.
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: null
    },
    showError: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      liability: new window.Form({
        type: this.type
      })
    };
  },

  computed: {
    liabilityTypes() {
      return this.$store.getters['LiabilityTypes/all'];
    }
  },

  mounted() {
    this.$store.commit('LiabilityTypes/retrieve');
    window.Ajax.get(`/incidents/${this.incident}`)
      .then(response => {
        this.$store.dispatch('Incident/setIncident', response.data);
      })
      .catch(error => {});
  },

  methods: {
    setLiability() {
      this.liability
        .post(`/incidents/${this.incident}/liability`)
        .then(response => {
          window.toastify.success(
            'Success!',
            'The liability was updated successfully!'
          );

          this.$store.commit('Incident/setLiabilityType', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error updating the liability type'
          );
        });
    }
  },

  watch: {
    type(value) {
      this.liability.type = value;
    }
  }
};
</script>
